export default "__VITE_ASSET__DEkQdrAx__"